var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-start flex-column header-gambit"},[_c('h3',{staticClass:"pt-15 text-h4 font-weight-bold"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{style:(!_vm.hasClass ? 'margin-bottom: 30px': 'margin-bottom: 64px')},[_vm._v(_vm._s(_vm.subtitle))]),_vm._v(" "),(_vm.hasSeparator)?_c('hr',{staticClass:"separator"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7988040f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = Q+TK
// module chunks = 1